module.exports = __webpack_public_path__ + "static/media/NotoSansSC-Medium-Alphabetic.bacba8e5.woff2";